import React from 'react'

export const createSyntheticEvent = <T extends Element, E extends Event>(event: E): React.SyntheticEvent<T, E> => {
  let isDefaultPrevented = false
  let isPropagationStopped = false
  const preventDefault = () => {
    isDefaultPrevented = true
    event.preventDefault()
  }
  const stopPropagation = () => {
    isPropagationStopped = true
    event.stopPropagation()
  }
  return {
    nativeEvent: event,
    currentTarget: event.currentTarget as EventTarget & T,
    target: event.target as EventTarget & T,
    bubbles: event.bubbles,
    cancelable: event.cancelable,
    defaultPrevented: event.defaultPrevented,
    eventPhase: event.eventPhase,
    isTrusted: event.isTrusted,
    preventDefault,
    isDefaultPrevented: () => isDefaultPrevented,
    stopPropagation,
    isPropagationStopped: () => isPropagationStopped,
    persist: () => {},
    timeStamp: event.timeStamp,
    type: event.type,
  }
}

/**
 * utility to mock a native Select onChange event
 * @param value value to transmit through event
 * @returns mocked onChange event
 */
export const mockSelectChangeEvent = (value: any, id?: string) => {
  const select = document.createElement('select')
  const option = document.createElement('option')
  option.value = value
  select.appendChild(option)
  select.value = value
  if (id) select.id = id
  const event = createSyntheticEvent(new Event('change')) as React.ChangeEvent<HTMLSelectElement>
  Object.defineProperty(event, 'target', {
    writable: false,
    value: select,
  })
  return event
}

/**
 * utility to mock a native Input onChange event
 * @param value value to transmit through event
 * @returns mocked onChange event
 */
export const mockInputChangeEvent = (value: any, checkbox: boolean = false) => {
  const input = document.createElement('input')
  if (checkbox) input.checked = value
  else input.value = value
  const event = createSyntheticEvent(new Event('change')) as React.ChangeEvent<HTMLInputElement>
  Object.defineProperty(event, 'target', {
    writable: false,
    value: input,
  })
  return event
}

/**
 * utility to mock a native click event
 * @returns mocked mouse click event
 */
export const mockButtonClickEvent = () => {
  const target = document.createElement('button')
  const event = createSyntheticEvent(new Event('click')) as React.MouseEvent<HTMLButtonElement>
  Object.defineProperty(event, 'target', {
    writable: false,
    value: target,
  })
  return event
}
